// extracted by mini-css-extract-plugin
export default {"hoverEffect":"HoverEffect_hoverEffect__-FY69"};